import {digits, email, is, max, min, min_value, required} from "vee-validate/dist/rules";
import {extend} from "vee-validate";

extend('required', {
  ...required,
  message: 'Questo campo è obbligatorio'
});

extend('digits', {
  ...digits,
  message: 'Questo campo può contenere solo numeri'
});

extend('email', {
  ...email,
  message: 'Inserisci un indirizzo email valido'
});

extend('partita_iva', {
  ...digits,
  message: 'Immetti un codice partita iva valido'
});

extend('recapito', {
  ...required,
  message: "Seleziona almeno un metodo di recapito"
});

extend('persone', {
  ...min_value,
  message: "Inserisci un numero valido di persone richieste"
});

extend('settori', {
  ...required,
  message: "Seleziona almeno un settore"
});

extend('mansioni', {
  ...required,
  message: "Seleziona almeno una mansione"
});

extend('periodoDa', {
  ...required,
  message: "Inserisci una data di inizio"
});

extend('periodoA', {
  ...required,
  message: "Inserisci una data di fine"
});

extend('periodoCheck', {
  params:['target'],
  // @ts-ignore
  validate(value, { target } ){
    let dateFrom = Date.parse(target);
    let dateTo = Date.parse(value);
    return dateFrom < dateTo;
  },
  message: "La data di fine periodo deve essere successiva a quella di inizio"
});

extend('email', {
  ...email,
  message: "Inserisci un indirizzo e-mail valido"
});

extend('contatto', {
  params:['target'],
  // @ts-ignore
  validate(value, { target } ){
    return value.length > 0 || target.length > 0
  },
  computesRequired: true,
  message: "Inserisci almeno un contatto fra telefono ed e-mail"
});

extend('password', {
  ...min,
  message: "La password deve essere lunga almeno 6 caratteri"
})

extend('confirmation', {
  params:['target'],
  // @ts-ignore
  validate(value, { target }){
    return value === target;
  },
  message: "Le password non corrispondono"
})

extend('codiceVerifica', {
  validate(value){
    return value.length === 6;
  },
  message: "Inserisci un codice di verifica valido"
})

extend('titolo', {
  ...max,
  message: "Questo campo può contenere al massimo 150 caratteri"
})

extend("privacy", {
  validate(value){
    return value
  },
  message: "Spunta per proseguire"
})

// extend('recapito', {
//   validate(value){
//     console.log(value)
//     return value.length > 0;
//   },
//   computesRequired: true,
//   message: "Seleziona almeno un recapito"
// });
